export type BqTagProps = {
  color: 'warn' | 'info' | 'success' | 'danger';
  className?: string;
  value: string;
};
export const BqTag = ({ className, value, color }: BqTagProps) => {
  return (
    <span
      className={`bq-badge-${color} bq-badge ${className ?? ''} inline-block cursor-pointer`}
    >
      {value}
    </span>
  );
};
